export default "__VITE_ASSET__CE6Rk0$E__"